import React from "react";
import { Box } from "@mui/material";
import { useGetAllowedValues, useSites, useGetConfigParameter, useAllCollectors, useUtilityBillsYears } from "hooks";
import { DashboardTabs } from "components";
import { TabName, SubTabName, TabComponent } from "./types";
import MainTab from "./components";

export const DashboardPageV2 = () => {
  const tabs: TabName[] = ["GHG Emissions", "Consumption", "Financials"];
  const initialTab: TabName = tabs[0];

  const subTabs: Record<TabName, SubTabName[]> = {
    "GHG Emissions": ["Location", "Market"],
    "Consumption": ["Overview", "Electricity", "Natural Gas", "Water", "Sewer"],
    "Financials": ["Overview", "Electricity", "Natural Gas", "Water", "Sewer"],
  };

  const { data: allowedValues } = useGetAllowedValues();
  const { data: sitesData } = useSites();
  const { data: configParameter } = useGetConfigParameter();
  const { data: collectorsData } = useAllCollectors();
  const { data: availableYears } = useUtilityBillsYears();

  const fiscalYears = availableYears ? availableYears && [...availableYears.map((yearItem: any) => `${yearItem}`)] : [];

  const allTabs: TabComponent[] = tabs.map((tab, index) => ({
    label: tab,
    content: <MainTab
      currentMainTab={tabs[index]}
      tabs={subTabs[tab]}
      allowedValues={allowedValues}
      sitesData={sitesData}
      configParameter={configParameter}
      collectorsData={collectorsData}
      fiscalYears={fiscalYears}
    />,
  }))

  return (
    <Box sx={{ ml: 3 }}>
      <DashboardTabs intensity tabs={allTabs} selectedBtnOption={initialTab} dashboard />
    </Box>
  );
}
